export default `
<section class="third bg-white container center pt-4">
<h2 class="h2 mb-2">++{{section15Header}}</h2>
<h6 class="p mb-3">
++{{section15Text}}
</h6>		
</section>
`